// ** IMPORTANT **: Keep in sync with functions/src/index.ts
export enum POST_CONTENT_SCOPE {
    root = 'root',
    chapter = 'chapter',
    section = 'section',
}
